<template>
  <v-container>
    <h1 id="user-header">Available Internships</h1>
    <h3 class="mb-5">
      Below is a list of available internships. Click apply to begin your
      application. You can apply to up to three.
    </h3>
    <v-data-table
      :headers="headers"
      :items="internships"
      :search="search"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      sort-by="name"
      :items-per-page="-1"
      hide-default-footer
      item-key="id"
      show-expand
      flat
    >
      <template v-slot:top>
        <v-toolbar flat>
          <div style="width: 50%">
            <v-text-field
              v-model="search"
              label="Search Internships"
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              no-results-text="No internships with this name available."
            ></v-text-field>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed to="/apply">Apply</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-4 description">
          {{
            item.description
              ? item.description
              : "No description for this internship. Contact " +
                item.contactName +
                " at " +
                item.contactEmail +
                " for more information."
          }}
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { getInternships } from "../services/services";

export default {
  name: "AvailableInternships",
  data() {
    return {
      internships: [],
      expanded: [],
      search: "",
      singleExpand: false,
      headers: [
        { text: "Internship Location", value: "name" },
        { text: "Timeline", value: "timeline" },
        { text: "Number of Students", value: "numStudents" },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  created() {
    getInternships().then((data) => {
      this.internships = data;
    });
  },
};
</script>

<style>
#user-header {
  text-align: left;
  font: normal normal bold 40px/47px "HCo Ringside Narrow SSm";
  letter-spacing: 0px;
  color: #002e5d;
  opacity: 1;
  margin-bottom: 30px;
}
.description {
  background-color: #f1f1f1;
}
</style>
